import React from "react";
import { Descriptions, Select } from "antd";
import { Goalie, Player } from "../../common/interfaces";
import { getDivisionName, getGoalieDisplayNameForMergeList, getPlayerDisplayForAdminPage } from "../../common/utils";

export type PlayerOrGoalie = Player | Goalie;

// isGoalie is passed in by the caller rather than inferred from the candidate's shape, since
// each merge page only ever deals with one kind and already knows which.
export function MergeCandidateInfo(props: {
  candidate: PlayerOrGoalie;
  isGoalie: boolean;
  title: string;
  loading: boolean;
  candidates: PlayerOrGoalie[];
  onChange: (id: number) => void;
}) {
  const { loading, onChange, candidate, isGoalie, candidates, title } = props;

  const getDisplay = (p: PlayerOrGoalie) =>
    isGoalie
      ? getGoalieDisplayNameForMergeList(p as Goalie)
      : getPlayerDisplayForAdminPage(p as Player);

  const isActiveLabel = candidate.id > 0 ? (candidate.active ? "Yes" : "No") : "";

  return (
    <>
      <Select
        showSearch={true}
        style={{ width: 250 }}
        placeholder={title}
        loading={loading}
        optionFilterProp={"children"}
        value={candidate.id > 0 ? candidate.id : undefined}
        onChange={onChange}
      >
        {candidates.map((p: PlayerOrGoalie) => (
          <Select.Option key={p.id} value={p.id}>
            {getDisplay(p)}
          </Select.Option>
        ))}
      </Select>
      <Descriptions title={title} column={1}>
        <Descriptions.Item label="Name">
          {candidate.firstName} {candidate.lastName}
        </Descriptions.Item>
        <Descriptions.Item label="Email">{candidate.email}</Descriptions.Item>
        <Descriptions.Item label="Active">{isActiveLabel}</Descriptions.Item>
        {isGoalie ? (
          <Descriptions.Item label="Eligible Divisions">
            {((candidate as Goalie).eligibleDivisions || []).map(getDivisionName).join(", ") || "None"}
          </Descriptions.Item>
        ) : (
          <>
            <Descriptions.Item label="Division">{getDivisionName((candidate as Player).division)}</Descriptions.Item>
            <Descriptions.Item label="Jersey #">{(candidate as Player).jerseyNumber}</Descriptions.Item>
            <Descriptions.Item label="Team">{(candidate as Player).teamName || "N/A"}</Descriptions.Item>
          </>
        )}
      </Descriptions>
    </>
  );
}
